import React from 'react';
import ArrowIcon from '~/common/images/black-carat.svg';
import { gtm, clickCtaEvent } from '~/common/utils/tracking';
import styles from './cell.css';

const Cell = ({ imgSrc, imgAltText, copy, title, callout, href }) => {
    return (
        <a
            className={styles.wrapper}
            href={href}
            onClick={() => {
                gtm(clickCtaEvent(title, href, 'three cell component'));
            }}
            target='_blank'
        >
            {imgSrc &&
                <img
                    alt={imgAltText} className={styles.img}
                    src={imgSrc}
                >
                </img>
            }
            {callout && <span className={styles.callout}>{callout}</span>}
            {title && <div className={styles['title-grp']}><h2 className={styles.title}>{title}</h2><img className={styles.icon} src={ArrowIcon}></img></div>}
            {copy && <p className={styles.copy}>{copy}</p>}
        </a>
    );
};

export default Cell;
